import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth, isOwner } from "@/lib/AuthContext";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import Callback from "@/pages/Callback";
import MagicLinkVerify from "@/pages/MagicLinkVerify";
import Dashboard from "@/pages/Dashboard";
import Quiz from "@/pages/Quiz";
import Insights from "@/pages/Insights";
import Dynamics from "@/pages/Dynamics";
import Field from "@/pages/Field";
import Library from "@/pages/Library";
import Reader from "@/pages/Reader";
import Profile from "@/pages/Profile";
import Checkout from "@/pages/Checkout";
import PurchaseComplete from "@/pages/PurchaseComplete";
import Unlock from "@/pages/Unlock";
import ArchetypeDetail from "@/pages/ArchetypeDetail";
import Admin from "@/pages/Admin";
import Manual from "@/pages/Manual";
import Faq from "@/pages/Faq";
import Legal from "@/pages/Legal";
import Loading from "@/components/app/Loading";
import Layout from "@/components/app/Layout";

function RequireAuth({ children, ownerOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading full />;
  if (!user) return <Navigate to="/login" replace />;
  if (ownerOnly && !isOwner(user)) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "var(--pa-card)",
              color: "var(--pa-text-primary)",
              border: "1px solid var(--pa-card-border)",
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/auth/verify" element={<MagicLinkVerify />} />

          <Route element={<RequireAuth><Layout /></RequireAuth>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/dynamics" element={<Dynamics />} />
            <Route path="/field" element={<Field />} />
            <Route path="/library" element={<Library />} />
            <Route path="/reader/:itemId" element={<Reader />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/unlock" element={<Unlock />} />
            <Route path="/archetype/:name" element={<ArchetypeDetail />} />
            <Route path="/checkout/:productId" element={<Checkout />} />
            <Route path="/purchase-complete" element={<PurchaseComplete />} />
            <Route path="/manual" element={<Manual />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/admin" element={<RequireAuth ownerOnly><Admin /></RequireAuth>} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
